import { fieldUIOverrides } from '../../../constants/uiOverrideConstants';

// API provides incorrect label values in some cases
// Overrides with appropriate values
const decorateWithUIOverrides = (steps: any) => {
  return steps.map((step: any) => {
    const { fields } = step;
    const decoratedFields = fields.map((field: any) => {
      return Object.assign(field, fieldUIOverrides[field.fieldId]);
    });
    const decoratedFieldsWithDecoratedLists = decoratedFields.map(
      ({ list, ...field }: any) => {
        return Object.assign(field, { list });
      }
    );
    return Object.assign(step, { fields: decoratedFieldsWithDecoratedLists });
  });
};

export default decorateWithUIOverrides;
try {
    // @ts-ignore
    decorateWithUIOverrides.displayName = "decorateWithUIOverrides";
    // @ts-ignore
    decorateWithUIOverrides.__docgenInfo = { "description": "", "displayName": "decorateWithUIOverrides", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/containers/stepContainer/dataTransform/decorateWithUIOverrides.ts#decorateWithUIOverrides"] = { docgenInfo: decorateWithUIOverrides.__docgenInfo, name: "decorateWithUIOverrides", path: "src/containers/stepContainer/dataTransform/decorateWithUIOverrides.ts#decorateWithUIOverrides" };
}
catch (__react_docgen_typescript_loader_error) { }